import React from 'react'
import Navbar from '../components/Navbar'
import styled from 'styled-components'
import Helmet from 'react-helmet'

const NotFoundPage = () => (
  <div>
    <Helmet>
      <title>404 - shotsnapp</title>
    </Helmet>
    <Navbar />
    <Wrapper>
      <h2>Page not found</h2>
    </Wrapper>
  </div>
)

export default NotFoundPage

const Wrapper = styled.div`
  color: #fff;
  text-align: center;
  width: 100%;
  overflow: hidden;
  padding: 150px 0 100px;
  min-height: 80vh;
  position: relative;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/pages/404.js